import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const documentTypeApi = createApi({
  reducerPath: 'documentTypeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['documentType'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getDocumentTypeList: builder.query({
      query: () => ({
        method: 'GET',
        path: 'DocTypes',
      }),
      providesTags: ['documentType'],
    }),
    createNewDocumentType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'DocTypes',
      }),
      invalidatesTags: ['documentType'],
    }),
    updateDocumentType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: 'DocTypes',
      }),
      invalidatesTags: ['documentType'],
    }),
    deleteDocumentType: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `DocTypes/${id}`,
      }),
      invalidatesTags: ['documentType'],
    }),
    activateDocumentType: builder.mutation({
      query: ({ id }) => ({
        method: 'PUT',
        path: `DocTypes/Activate?id=${id}`,
      }),
      invalidatesTags: ['documentType'],
    }),
    deactivateDocumentType: builder.mutation({
      query: ({ id }) => ({
        method: 'PUT',
        path: `DocTypes/Deactivate?id=${id}`,
      }),
      invalidatesTags: ['documentType'],
    }),
  }),
});
export const documentTypeApiReducerName = documentTypeApi.reducerPath;
export const documentTypeApiReducer = documentTypeApi.reducer;
export const documentTypeApiMiddleware = documentTypeApi.middleware;

export const {
  useGetDocumentTypeListQuery,
  useCreateNewDocumentTypeMutation,
  useUpdateDocumentTypeMutation,
  useDeleteDocumentTypeMutation,
  useActivateDocumentTypeMutation,
  useDeactivateDocumentTypeMutation,
} = documentTypeApi;
